<template>
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 1.6C8.88 1.6 9.52 2.32 9.44 3.2L8.8 9.6H7.2L6.56 3.2C6.48 2.32 7.12 1.6 8 1.6ZM8 14.4C7.12 14.4 6.4 13.68 6.4 12.8C6.4 11.92 7.12 11.2 8 11.2C8.88 11.2 9.6 11.92 9.6 12.8C9.6 13.68 8.88 14.4 8 14.4Z"
      fill="#DD1515"/>
</svg>
</template>
